import React, { Component } from 'react';
import i18n from '../../i18n';
import { SelectBox } from 'devextreme-react';
import { SERVICE_NOTE_TYPE } from '../../constants/Config';
import PropTypes from 'prop-types';
class ServiceNoteTypeSelectBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: {},
            payload: {}
        };

        this.onDataChanged = this.onDataChanged.bind(this);
    }

    componentDidMount() {
        this.handleLanguage();
    }

    handleLanguage = () => {
        const { languages } = this.props;

        let datas = [];

        languages.forEach(element => {
            const newArray = [];

            for (const item of SERVICE_NOTE_TYPE) {
                const i = Object.assign({}, item);
                const nameParse = (i.name ? JSON.parse(i.name) : '');

                i.name = nameParse[element.languageId];
                newArray.push(i);
            }

            datas = { ...datas, [element.languageId]: newArray };
        });

        this.setState({
            datas
        });
    }

    /**
     * Handle Data Change.
     *
     * @inheritdoc
     */
    onDataChanged(e) {
        const { field } = this.props;
        if (e.value !== null) {
            this.props.updateData({
                [field]: e.value
            });
        } else {
            this.props.updateData({
                [field]: null
            });
        }
    }

    render() {
        const { currentLanguageActive, value, i18nLabel } = this.props;
        const { datas } = this.state;

        return (
            <div className="form-group cm-mgr-5">
                <div className={'dx-field'}>
                    <SelectBox
                        searchEnabled={true}
                        items={datas[currentLanguageActive]}
                        value={value}
                        valueExpr={'id'}
                        displayExpr={'name'}
                        placeholder={i18n.t(i18nLabel)}
                        showClearButton={true}
                        onValueChanged={this.onDataChanged}
                    />
                </div>
            </div>
        );
    }
}

ServiceNoteTypeSelectBox.propTypes = {
    languages: PropTypes.array
};
export default ServiceNoteTypeSelectBox;
